import { Client } from "./_clientService";

async function getFatigueConfig() {
  try {
    let path = "/fatigue/config";
    const resp = await new Client({ path }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateFatigueConfig(fatigueConfig: any) {
  try {
    const resp = await new Client({
      path: "/fatigue/update",
      payload: { ...fatigueConfig },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export {
  getFatigueConfig,
  updateFatigueConfig,
};